import React, { Component } from 'react';
import "../../css/RegistroFirma.css";
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import CrearFirmaElectronica from './CrearFirmaElectronica';
import CrearFirmaIcon from '../../assets/CrearfirmaICO.svg';
import "../../css/Modal.css";  // Importamos el archivo CSS del modal
import MenuUsuario from './MenuUsuario';
import jwt from 'jwt-decode'
import Cookies from 'js-cookie';
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';
import { ReactComponent as FirmaSubidaIcon } from '../../assets/FirmaSUBIDA(ESPOL).svg';
import { validarRenovacionFirma } from "../../utils/funciones";

export default class RegistroFirma extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firmas: [],  // Inicializado vacío para que las filas se agreguen dinámicamente
      modalVisible: false,  // Estado para controlar la visibilidad del modal
      //canCreateFirma: true,
      msgVisible: false,            // Modal de mensajes (info/error)
      msgTitle: '',
      msgBody: '',
      nombre_completo: '',
      loading: true,
      msgFirmas: '',
      cuentaRecuperacionesDisponibles: 3,
      habilitadoRenovar: false,
      mostrarMensajehabilitadoRenovar:false,
    };
  }

  componentDidMount() {
    this.handleloadfirmas();

    var token = Cookies.get("token");
    var tokendecode = jwt(token);
    this.setState({
      nombre_completo: tokendecode["Nombres"] + " " + tokendecode["Apellidos"]
    });
  }

  /*validarRenovacionFirma = () => {
    var habilitadoRenovar = true;
    fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ValidarRenovacionDeFirmasByPersona`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem("access_token")}`,
      },
    })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(
          "Ocurrió un problema en el servidor de las firmas. Por favor, intenta nuevamente más tarde."
        );
      }
      return response.json();
    })
    .then((data) => {
      if (!data.status?.isSuccessfully) {
        throw new Error("Error en el servicio de validación de renovación de firma.");
      }
      var habilitadoRenovar_temp = data.data.habilitadoRenovar;
      console.log(habilitadoRenovar_temp);

      var bol_temp = habilitadoRenovar_temp ? false : true;

      this.setState({
        habilitadoRenovar:habilitadoRenovar_temp,
        mostrarMensajehabilitadoRenovar: bol_temp
      });
      
    })
    .catch((error) => {
      let mensaje = error.message;
      if (mensaje === "Failed to fetch") {
        mensaje = "No fue posible conectarse al servidor de firmas. Verifique su conexión o CORS.";
      }
      this.openMsgModal(
        "No se pudo validar el estado de las firmas.",
        mensaje
      );
    });
  }*/

  handleloadfirmas = async () => {
  this.setState({
    loading: true,
    habilitadoRenovar: false
  });

  const token = sessionStorage.getItem("access_token");
  if (!token) {
    this.openMsgModal(
      "Sesión no válida",
      "No se encontró un token de acceso. Inicia sesión nuevamente para continuar."
    );
    this.setState({ loading: false });
    return;
  }

  try {
    // 1. Petición de firmas de la persona
    const response = await fetch(`${process.env.REACT_APP_API_FIRMAS}/FirmaElectronica/ObtenerFirmasByPersona`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      let errText = '';
      try { errText = await response.text(); } catch (_) { }
      throw new Error(errText || `Error ${response.status}`);
    }

    const data = await response.json();

    const formatDate = (dateString) => {
      if (!dateString) return "";
      return dateString.replace("T", " ").split(".")[0];
    };

    const firmas = Array.isArray(data?.listData)
      ? data.listData.map((firma) => ({
        firma: <FirmaSubidaIcon width={30} />,
        fechaSubida: formatDate(firma.fechaemision),
        fechaCaducidad: formatDate(firma.fechavencimiento),
        estadoFirma: firma.estado
      })) : [];

    const anioActual = new Date().getFullYear();
    const firmasDelAnio = firmas.filter(f => {
      if (!f.fechaSubida) return false;
      const anioEmision = new Date(f.fechaSubida).getFullYear();
      return anioEmision === anioActual;
    });

    const cuentaRecuperacionesDisponibles = 3 - firmasDelAnio.length;

    // 2. Llamada a la función genérica
    const datosRenovacion = await validarRenovacionFirma();

    // 3. Actualización de estado en una sola llamada
    this.setState({
      firmas,
      cuentaRecuperacionesDisponibles,
      ...datosRenovacion // Asigna habilitadoRenovar y mostrarMensajehabilitadoRenovar
    });

  } catch (error) {
    this.openMsgModal(
      "Ocurrió un error",
      error.message || "No se pudieron obtener las firmas."
    );
  } finally {
    this.setState({ loading: false });
  }
};





  openMsgModal = (title, body) => {
    this.setState({ msgVisible: true, msgTitle: title, msgBody: body });
  };

  closeMsgModal = () => {
    this.setState({ msgVisible: false, msgTitle: '', msgBody: '' });
  };

  handleCrearFirma = () => {
    this.setState({ modalVisible: true });
  };
  handleCrearFirma = () => {
    /*if (!this.state.canCreateFirma) {
      this.openMsgModal(
        "Acción no permitida",
        "Ya tienes una firma vigente. Solo podrás crear una nueva cuando la actual caduque."
      );
      return;
    }*/
    this.setState({ modalVisible: true });
  };

  closeCrearModal = () => {
    this.setState({ modalVisible: false });
  };

  closeModal = () => {
    this.setState({ modalVisible: false });
  };


  render() {
    const { modalVisible, msgVisible, msgTitle, msgBody, cuentaRecuperacionesDisponibles, habilitadoRenovar } = this.state;
    return (
      <div>
        <MenuUsuario
          mostrarNombre={true}
          nombresCompletos={this.state.nombre_completo}
        />

        <Header />
        <div className="registrofirma-container">

          {!modalVisible && (
            <div className="row-registrofirma-title">
              <p className="registrofirma-title"><b>FIRMAS REGISTRADAS</b></p>
            </div>
          )}


          {!modalVisible && (
            <div className="registrofirma-buttons">
              <button className="modal-modalFM-botones" onClick={this.handleCrearFirma}
                disabled={!this.state.habilitadoRenovar}
                style={{
                  cursor: this.state.habilitadoRenovar ? 'pointer' : 'not-allowed', // Cambia el cursor cuando está deshabilitado
                  opacity: this.state.habilitadoRenovar ? 1 : 0.5 // Cambia la opacidad para mostrar que está deshabilitado
                }}
              >

                <img src={CrearFirmaIcon} alt="Crear Firma" className="crear-firma-icon" />Crear Firma
              </button>
            </div>
          )}
          {/*#cuentaRecuperacionesDisponibles <= 0 && (
            <div className='alert alert-danger'><i className="bi bi-exclamation-triangle-fill me-2"></i>
            Estimado, usted ya ha solicitado 3 firmas en el año en curso. No puede solicitar más.</div>
          )*/}
          {(!habilitadoRenovar && this.state.mostrarMensajehabilitadoRenovar) && (
            <div className='alert alert-danger'><i className="bi bi-exclamation-triangle-fill me-2"></i>
              Estimado, usted ya ha solicitado 3 o más firmas en el año en curso.<br />
                <span className='olvContra-mdl-text' align="justify">En caso de requerir la generación de una nueva firma, tendrá que acercarse a la Gerencia de tecnologías y sistemas de información, GTSI, para solicitar la apertura del formulario de creación de nueva firma espol.
              </span>
              
              
            </div>
          )}
          {modalVisible && (
            <div className="modal-background">
              <div className="modal-container">
                <div className="modal-header1">
                  <h3 className="h3">CREAR FIRMA ELECTRÓNICA</h3>
                  <button className="modal-close" onClick={this.closeModal}>&times;</button>
                </div>
                <CrearFirmaElectronica
                  modalVisible={modalVisible}
                  setModalVisible={(value) => this.setState({ modalVisible: value })}
                  handleloadfirmas={this.handleloadfirmas}
                />
              </div>
            </div>
          )}



          {/* Modal de MENSAJES (info/error) */}
          {msgVisible && (
            <div className="modal-background">
              <div className="modal-container">
                <div className="modal-header1">
                  <h3 className="h3">{msgTitle}</h3>
                  <button className="modal-close" onClick={this.closeMsgModal}>&times;</button>
                </div>
                <div className="modal-body">
                  <p>{msgBody}</p>
                </div>
                <div className="modal-actions">
                  <button className="modal-primary-btn" onClick={this.closeMsgModal}>
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          )}

          {!modalVisible && (
            <table className="table">
              <thead>
                <tr>
                  <th>Firma subida</th>
                  <th>Fecha de creación</th>
                  <th>Fecha de caducidad</th>
                </tr>
              </thead>
              <tbody>
                {this.state.loading ? (
                  <tr>
                    <td colSpan="3" style={{ textAlign: 'center', padding: 20 }}>
                      <ComponenteSpinner />
                    </td>
                  </tr>
                ) : this.state.firmas.length > 0 ? (
                  this.state.firmas
                    .slice()
                    .sort((a, b) => {
                      // Primero van las activas
                      if (a.estadoFirma === "A" && b.estadoFirma === "I") return -1;
                      if (a.estadoFirma === "I" && b.estadoFirma === "A") return 1;

                      // Si ambas son inactivas, ordenar por fechaSubida DESC
                      if (a.estadoFirma === "I" && b.estadoFirma === "I") {
                        return new Date(b.fechaSubida) - new Date(a.fechaSubida);
                      }

                      // Si ambas son activas, mantener el orden
                      return 0;
                    })
                    .map((firma, index) => {
                      const hoy = new Date();
                      const fechaCaducidad = new Date(firma.fechaCaducidad);
                      const vencida = fechaCaducidad < hoy;
                      const esInactiva = firma.estadoFirma === "I";

                      return (
                        <tr key={index} className={`${vencida || esInactiva ? 'firma-vencida' : 'habilitada firma-activa'}`}>
                          <td>{firma.firma}</td>
                          <td>{firma.fechaSubida}</td>
                          <td>{firma.fechaCaducidad}</td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="3" style={{ padding: 16, fontStyle: 'italic' }}>
                      No hay firmas registradas.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

